/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import {Link, withPrefix} from 'gatsby';
import {VerticalNavigation, Navigation} from '@homeaway/react-navigation';
import cx from 'classnames';
import {LocaleContext} from '../../context';
import types from '../../types';
import './Layout.less';

const getLanguageLinks = ({allLocales, localizedDocumentLinks = []}) =>
    allLocales
        .sort((a, b) => b.contentful - a.contentful)
        .map((locale) => {
            // navigate to equivalent home page
            let to = locale.path;
            // else, navigate to equivalent document
            if (localizedDocumentLinks.length) {
                const localizedDocumentLink = localizedDocumentLinks.find(
                    ({node_locale}) => locale.contentful === node_locale,
                );

                if (localizedDocumentLink) {
                    to = localizedDocumentLink.route;
                }
            }
            return {
                href: withPrefix(to),
                label: locale.name,
                node: <Link to={to}>{locale.name}</Link>,
            };
        });

export default function LegalLayout({
    pathname,
    allLocales,
    contentfulLocale,
    localizedDocumentLinks = [],
    children,
}) {
    const withLanguageNav = allLocales.length > 1;
    let languageNavLinks;
    let activeIndex;

    if (withLanguageNav) {
        languageNavLinks = getLanguageLinks({
            allLocales,
            localizedDocumentLinks,
        });

        activeIndex =
            // findIndex returns -1 if gcb helement isn't found, so fallback to 0
            languageNavLinks.findIndex(({href}) => href === pathname) || 0;
    }
    return (
        <LocaleContext.Provider value={contentfulLocale}>
            <div
                className={cx('ContentArea', 'container', {
                    'ContentArea--withNav': withLanguageNav,
                })}
            >
                {withLanguageNav && (
                    <div className="ContentArea__LanguageNav">
                        <VerticalNavigation
                            activeIndex={activeIndex}
                            links={languageNavLinks}
                        />
                        <Navigation
                            activeIndex={activeIndex}
                            links={languageNavLinks}
                        />
                    </div>
                )}
                <div className="ContentArea__Main">{children}</div>
            </div>
        </LocaleContext.Provider>
    );
}

LegalLayout.propTypes = {
    allLocales: types.allLocales,
    pathname: PropTypes.string.isRequired,
    localizedDocumentLinks: types.documentLinksArray,
};
